<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <g>
    <g>
      <path class="filled" d="M47.149,54.459h-30.3a5.55,5.55,0,0,1-5.55-5.55V15.091a5.55,5.55,0,0,1,5.55-5.55H31.582a1.11,1.11,0,0,1,1.11,1.11v2.22a1.11,1.11,0,0,1-1.11,1.11H16.851a1.11,1.11,0,0,0-1.11,1.11V48.909a1.11,1.11,0,0,0,1.11,1.11h30.3a1.11,1.11,0,0,0,1.11-1.11V30.582a1.11,1.11,0,0,1,1.11-1.11h2.22a1.11,1.11,0,0,1,1.11,1.11V48.909A5.55,5.55,0,0,1,47.149,54.459Z" fill="currentColor"/>
      <rect class="filled" x="23.51" y="29.911" width="16.98" height="4.44" rx="1.11" fill="currentColor"/>
      <rect class="filled" x="23.51" y="38.786" width="16.98" height="4.44" rx="1.11" fill="currentColor"/>
      <rect class="filled" x="23.51" y="21.036" width="9.198" height="4.44" rx="1.11" fill="currentColor"/>
      <path class="filled" d="M38.1,11.774V20.9a3.33,3.33,0,0,0,3.33,3.33h9.123a1.11,1.11,0,0,0,.785-1.895L40,10.989A1.11,1.11,0,0,0,38.1,11.774Z" fill="currentColor"/>
    </g>
    <rect width="64" height="64" fill="none"/>
  </g>
</svg>
